































import { Component, Prop, Watch } from 'vue-property-decorator';
import { RiskMeterSpec } from './types';
import { SwExtendedVue } from '../../../../../libs/unified-ui-framework/src/shared/sw-extended-vue';

const d3 = require('d3');
const cssPrefix = 'sw-risk-meter';

@Component({
  components: {
  },
})
export default class SwRiskMeter extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ type: Object, required: true })
  chartData: RiskMeterSpec;

  readingEffectCount: number = 0;

  get countLabel() {
    return this.readingEffectCount;
  }

  get data2() {
    const {
      fixedPathCount,
      arcEndAngle,
      colorStart,
      colorEnd,
    } = this.graphProps;
    const colorScale = d3.scaleSequential(d3.interpolate(colorStart, colorEnd))
    .domain([0, fixedPathCount]);
    return d3.range(fixedPathCount)
      .map((d: any, i: any) => {  // tslint:disable-line
        const j = i;
        return { arcStartAngle: j * (arcEndAngle / fixedPathCount), arcEndAngle: (j + 2) * (arcEndAngle / fixedPathCount), fill: colorScale(j) };
      });
  }

  get arc() {
    const {
      arcInnerRadius,
      arcOuterRadius,
    } = this.graphProps;
    return d3.arc()
      .innerRadius(arcInnerRadius)
      .outerRadius(arcOuterRadius)
      .startAngle((d: any) => { return d.arcStartAngle; })
      .endAngle((d: any) => { return d.arcEndAngle; })
      .cornerRadius(100);
  }
  get arcCircle() {
    const {
      arcInnerRadius,
      arcOuterRadius,
      needleCornerRadius,
      arcCurveStartAngle,
    } = this.graphProps;
    return d3.arc()
      .innerRadius(arcInnerRadius)
      .outerRadius(arcOuterRadius)
      .startAngle((d: any) => { return this.scale(d) + arcCurveStartAngle; })
      .endAngle((d: any) => { return this.scale(d); })
      .cornerRadius(needleCornerRadius);
  }
  getChartWH() {
    const props = this.graphProps;
    const theme = typeof props.theme !== 'undefined' && props.theme === 'dark' ? { backgroundColor: '#333' } : {};
    return Object.assign({
      height: `${props.compHeight}%`,
      width: `${props.compWidth}%`,
    }, theme); // tslint:disable-line
  }

  get graphData() {
    return typeof this.chartData.data !== 'undefined' ? this.chartData.data : [];
  }

  get graphProps() {
    const predefined = {
      theme: 'dark',
      compWidth: 50,
      compHeight: 50,
      svgWidth: 960,
      svgHeight: 960,
      viewBoxWidth: 800,
      viewBoxHeight: 600,
      compX: 400,
      compY: 400,
      colorStart: '#c72928',
      colorEnd: '#abee4b',
      needleColor: '#ef8038',
      // ----------- Advanced settings ------------
      // strokeColor: '#fff',
      needleDuration: 1000,
      tooltipWidth: 500,
      tooltipHeight: 500,
      tooltipPlacement: 'auto',
      meterLabelTop: 185,
      // meterLabelColor: '#d7d7d7',
      meterLabelFont: '5.6rem',
      // meterBackground: '#333',
      percentageReadingHeight: -50,
      // percentageReadingColor: '#d7d7d7',
      percentageReadingFont: '16rem',
      needleCornerRadius: 50,
      arcInnerRadius: 300,
      arcOuterRadius: 360,
      strokeWidth: 10,
      needleInnerRadius: 280,
      needleOuterRadius: 380,
      arcStartAngle: 0,
      arcEndAngle: 1.1 * Math.PI, // Half circle
      needleStartAngle: -(0.095) * Math.PI,
      arcCurveStartAngle: -(0.06) * Math.PI,
      axisRotateAngle: 261,
      fixedPathCount: 1000,
    };
    return typeof this.chartData.props !== 'undefined' ? Object.assign({}, predefined, this.chartData.props) : predefined;
  }

  get scale() {
    const {
      totalReading: max,
    } = this.graphData;
    const {
      arcStartAngle,
      arcEndAngle,
    } = this.graphProps;
    return d3.scaleLinear()
      .domain([0, max])
      .range([arcStartAngle, arcEndAngle]);
  }

  get needleTween() {
    const {
      needleReading: needleEndAngle,
    } = this.graphData;
    const {
      needleInnerRadius,
      needleOuterRadius,
      needleStartAngle,
      needleCornerRadius,
    } = this.graphProps;
    const needleStartAngleCorrection: number = this.scale(needleEndAngle) + needleStartAngle;
    const needleEndAngleCorrection: number = this.scale(needleEndAngle);
    const needleAngleCorrection: number = (needleEndAngleCorrection - needleStartAngleCorrection) / 2;
    const needle = d3.arc()
      .innerRadius(needleInnerRadius)
      .outerRadius(needleOuterRadius)
      .startAngle((d: any) => { return this.scale(d) + needleStartAngle + needleAngleCorrection; })
      .endAngle((d: any) => { return this.scale(d) + needleAngleCorrection; })
      .cornerRadius(needleCornerRadius);
    return (d: any) => {
      const interpolate = d3.interpolate(0, d.value);
      return (t: any) => { return needle(interpolate(t)); };
    };
  }

  @Watch('chartData')
  processGraph() {
    const data = JSON.parse(JSON.stringify(this.graphData));
    const {
      totalReading: max,
      needleReading: needleEndAngle,
    } = data;
    const {
      needleDuration,
    } = this.graphProps;

    const svg = d3.select(`.${cssPrefix}`);
    const riskMeter = svg.select(`.${cssPrefix}__arc--wrap`);
    riskMeter.select(`.${cssPrefix}__arc--needle`)
      .transition()
      .delay(300)
      .duration(needleDuration)
      .attrTween('d', () => {
        // if (needleEndAngle) {
        return this.needleTween({ value: needleEndAngle });
        // }
        // this.$nextTick(() => {
        //   return this.needleTween({ value: needleEndAngle });
        // });
      });

    const meterEffect = (currentReading: any, totalReading: any, needleDuration: any) => {
      const percentage = Math.round(currentReading * 100 / totalReading);
      const timeInterval = (needleDuration / percentage);
      const stopInterval = setInterval(() => {
        if (this.readingEffectCount > Number(percentage)) {
          clearInterval(stopInterval);
          this.readingEffectCount = Number(percentage);
        } else if (this.readingEffectCount < Number(percentage)) {
          this.readingEffectCount += 1;
        } else if (this.readingEffectCount === Number(percentage)) {
          clearInterval(stopInterval);
        }
      }, timeInterval); // tslint:disable-line
    };
    meterEffect(needleEndAngle, max, needleDuration);
  }

  created() {
    this.processGraph();
  }

  updated() {
    // const percentage = Math.round(this.graphData.needleReading * 100 / this.graphData.totalReading);
    // if (this.readingEffectCount > percentage) {
    //   this.readingEffectCount = 0;
    //   this.processGraph();
    // }
    this.processGraph();
  }

  // beforeDestroy() {
  //   this.readingEffectCount = 0;
  // }
}
